"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSavePersonalProductList = void 0;
var PplAnalyticsEvent = _interopRequireWildcard(require("@ori-events/personal-product-list"));
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _router = require("next/router");
var _react = require("react");
var _api = require("../api");
var _constants = require("../constants");
var _personalProductListEditContext = require("../contexts/personalProductListEditContext");
var _models = require("../models");
var _utils = require("../utils");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const useSavePersonalProductList = ()=>{
    const { customerId } = (0, _auth.useToken)();
    const globalApiClient = (0, _globalApiClientReact.useApiClient)();
    const { personalProductListDetail: productList, maximumAllowedPersonalProductLists, personalProductListsCount, products, setIsMaximumRecordsReached } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const { push } = (0, _router.useRouter)();
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { trigger: saveProductList, isMutating } = (0, _fetching.useSWRMutation)([
        'savePersonalProductList',
        customerId
    ], async (_, param)=>{
        let { arg } = param;
        const { name, productListType, products: argProducts, productList: argProductList } = arg;
        return (argProductList === null || argProductList === void 0 ? void 0 : argProductList.productListId) ? (0, _api.updateProductList)({
            customerId,
            globalApiClient,
            name,
            productListType,
            products: argProducts,
            productList: argProductList
        }) : (0, _api.createProductList)({
            customerId,
            globalApiClient,
            name,
            productListType,
            products: argProducts
        });
    }, {
        onError: ()=>setIsLoading(false)
    });
    const onSave = (0, _react.useCallback)(async (param)=>{
        let { name } = param;
        setIsLoading(true);
        if ((0, _utils.isMaximumListCountReached)({
            maximumAllowedPersonalProductLists,
            personalProductListsCount,
            productListId: productList === null || productList === void 0 ? void 0 : productList.productListId
        })) {
            setIsMaximumRecordsReached(true);
            setIsLoading(false);
            return;
        }
        const newProductListType = _models.ProductListType.Personal;
        const data = await saveProductList({
            name,
            productListType: newProductListType,
            products,
            productList
        });
        var _data_name, _ref, _data_productListId, _ref1, _data_items_length;
        window.dispatchEvent(new CustomEvent(PplAnalyticsEvent.Name, {
            detail: {
                action: (productList === null || productList === void 0 ? void 0 : productList.productListId) ? PplAnalyticsEvent.PersonalProductListAction.Update : PplAnalyticsEvent.PersonalProductListAction.Create,
                listType: PplAnalyticsEvent.PersonalProductListType.Personal,
                listName: (_ref = (_data_name = data === null || data === void 0 ? void 0 : data.name) !== null && _data_name !== void 0 ? _data_name : productList === null || productList === void 0 ? void 0 : productList.name) !== null && _ref !== void 0 ? _ref : '',
                listId: (_ref1 = (_data_productListId = data === null || data === void 0 ? void 0 : data.productListId) !== null && _data_productListId !== void 0 ? _data_productListId : productList === null || productList === void 0 ? void 0 : productList.productListId) !== null && _ref1 !== void 0 ? _ref1 : '',
                itemsCount: (_data_items_length = data === null || data === void 0 ? void 0 : data.items.length) !== null && _data_items_length !== void 0 ? _data_items_length : products.length
            }
        }));
        await push((data === null || data === void 0 ? void 0 : data.productListId) ? "".concat(_constants.BASE_PATH, "/product-list/").concat(newProductListType.toLowerCase(), "/").concat(data.productListId) : _constants.BASE_PATH);
    }, [
        maximumAllowedPersonalProductLists,
        personalProductListsCount,
        productList,
        setIsMaximumRecordsReached,
        products,
        saveProductList,
        push
    ]);
    return {
        onSave,
        isLoading: isMutating || isLoading
    };
};
exports.useSavePersonalProductList = useSavePersonalProductList;
